import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FamilyMemberReadonly } from 'enrollment/features/Shared';
import {
  DecisionIQInfoBottomStyled,
  DecisionIQRowStyled,
} from '../../DecisionIQStyled';
import { DecisionIQDoctorFrequencyProps } from '.';
import { Loader, Spacer } from 'theSource/components';
import { useDecisionIQSurveyQuery } from 'enrollment/queries';
import { getUtilizationIndex } from '../..';
import { PsRadioTuner } from 'stencilSetup';

export const DocFrequencySelect = ({
  dependents,
  subscriber,
  orgBenefitId,
}: DecisionIQDoctorFrequencyProps) => {
  const { t } = useTranslation('pages.decisionIQ');
  const radioLabels = [t('often'), t('average'), t('rarely')];

  const [isCheckedArray, setIsCheckedArray] = useState<string[][]>([]);
  const [initValuesLoaded, setInitValuesLoaded] = useState(false);

  const {
    decisionIQSurveyData,
    isFetchingDecisionIQSurveys,
    isLoadingDecisionIQSurveys,
  } = useDecisionIQSurveyQuery({
    orgBenefitId: orgBenefitId,
    enabled: orgBenefitId > 0,
  });

  useEffect(() => {
    if (
      decisionIQSurveyData &&
      decisionIQSurveyData.data.questions.length > 0
    ) {
      const checkedValues = decisionIQSurveyData.data.questions[1].options.map(
        (option) => option['is_checked?']
      );
      setIsCheckedArray(checkedValues);
      setInitValuesLoaded(true);
    }
  }, [decisionIQSurveyData]);

  if (
    isLoadingDecisionIQSurveys ||
    isFetchingDecisionIQSurveys ||
    !initValuesLoaded
  ) {
    return <Loader />;
  }

  return (
    <div role="region" aria-labelledby="frequencyText">
      <DecisionIQRowStyled className="py-2 family-members" role="group">
        <FamilyMemberReadonly
          isTable={true}
          name={
            subscriber?.first_name.value + ' ' + subscriber?.last_name.value
          }
          relationship="You"
          profile={subscriber?.subscriber_profile}
          extraClass="decIQ-member"
          id="subscriber"
        />
        <div className="timing" role="group" aria-labelledby="subscriber">
          {
            // AI Tool assistance start (with edits made)
            radioLabels.map((label, index) => (
              <DecisionIQInfoBottomStyled
                className="frequency-radio"
                key={`radio-${index}-subscriber`}
              >
                <PsRadioTuner
                  inputId={`radio-${index}-subscriber`}
                  name="radio-subscriber"
                  label={label}
                  checked={
                    isCheckedArray[0] &&
                    isCheckedArray[getUtilizationIndex(index) - 1].includes(
                      'emp'
                    )
                  }
                />
                <Spacer width={12} />
              </DecisionIQInfoBottomStyled>
            ))
            // AI Tool assistance end
          }
        </div>
      </DecisionIQRowStyled>
      {dependents?.data?.dependents &&
        dependents.data.dependents.map((dependent, index) => (
          <DecisionIQRowStyled
            key={index}
            className="border-top py-2 family-members"
            role="group"
            aria-labelledby={(
              dependent.first_name + dependent.last_name
            ).replace(/\s+/g, '')}
          >
            <FamilyMemberReadonly
              isTable={true}
              name={dependent.first_name + ' ' + dependent.last_name}
              id={(dependent.first_name + dependent.last_name).replace(
                /\s+/g,
                ''
              )}
              relationship={dependent.relationship_code}
              profile={dependent.dependent_profile}
              extraClass="decIQ-member"
            />
            <div className="timing">
              {
                // AI Tool assistance start (with edits made)
                radioLabels.map((label, index) => (
                  <DecisionIQInfoBottomStyled
                    className="frequency-radio"
                    key={`radio-${index}-dependent-${dependent.id}`}
                  >
                    <PsRadioTuner
                      inputId={`radio-${index}-dependent-${dependent.id}`}
                      name={`radio-dep-${dependent.id}`}
                      label={label}
                      checked={
                        isCheckedArray[0] &&
                        isCheckedArray[getUtilizationIndex(index) - 1].includes(
                          String(dependent.id)
                        )
                      }
                    />
                    <Spacer width={12} />
                  </DecisionIQInfoBottomStyled>
                ))
                // AI Tool assistance end
              }
            </div>
          </DecisionIQRowStyled>
        ))}
    </div>
  );
};
